import { faker } from '@faker-js/faker'

import { countComments } from '~/modules/post/utils'
import mockComment from './mockComment'
import thumbnails from './thumbnails'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'service' implicitly has an 'any' type.
const getThumbnail = (service) => {
  const thumbnail = faker.helpers.arrayElement(thumbnails)
  return service === 'instagram' || Math.random() > 0.3 ? thumbnail : null
}

/**
 *
 */
export default function mockPost({
  comments = 0,
  service = 'instagram',
  override = {},
} = {}) {
  const postBase = {
    id: faker.string.uuid(),
    organizationId: faker.string.uuid(),
    channelService: service,
    channelServiceId: faker.string.uuid(),
    createdAt: faker.date.past({ years: 2 }),
    updatedAt: faker.date.past({ years: 2 }),
    commentsUpdatedAt: faker.date.past({ years: 1 }),
    deleted: false,
    backfilling: false,
    isGiveaway: faker.datatype.boolean(),
    dismissingAll: false,
    text: faker.lorem.paragraph(),
    mediaUrl: getThumbnail(service),
    permalink: 'http://buffer.com',
    totalLikes: faker.number.int(),
    totalComments: faker.number.int(),
    totalPendingComments: faker.number.int(),
    comments: [],
    labelsCount: [],
  }

  const commentsCount =
    comments !== undefined ? comments : faker.number.int({ min: 1, max: 10 })

  for (let c = 0; c < commentsCount; c++) {
    const replies = faker.number.int({ min: 0, max: 10 })
    const comment = mockComment({ replies, service })
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; text: string; crea... Remove this comment to see the full error message
    postBase.comments.push(comment)
  }

  const post = {
    ...postBase,
    ...override,
  }

  const count = countComments(post.comments)

  post.totalPendingComments =
    // @ts-expect-error TS(2339) FIXME: Property 'totalPendingComments' does not exist on ... Remove this comment to see the full error message
    override?.totalPendingComments !== undefined
      ? // @ts-expect-error TS(2339) FIXME: Property 'totalPendingComments' does not exist on ... Remove this comment to see the full error message
        override.totalPendingComments
      : count.totalPendingComments

  post.labelsCount =
    // @ts-expect-error TS(2339) FIXME: Property 'labelsCount' does not exist on type '{}'... Remove this comment to see the full error message
    override?.labelsCount !== undefined ? override.labelsCount : count.labels

  return post
}
